module.exports = __webpack_public_path__ + "img/dish-placeholder.a6c7b23a.svg";